import React from "react";
import styled from "styled-components";
import logoVector1 from "../assets/images/logo-vector1.svg";
import logoVector2 from "../assets/images/logo-vector2.svg";
import logoVector3 from "../assets/images/logo-vector3.svg";

const Logo: React.FC = () => {
  return (
    <LogoContainer>
      <LogoImageWrapper>
        <LogoImage src={logoVector1} alt="Ortix Glow Logo Part 1" />
        <LogoImage src={logoVector2} alt="Ortix Glow Logo Part 2" />
        <LogoImage src={logoVector3} alt="Ortix Glow Logo Part 3" />
      </LogoImageWrapper>
    </LogoContainer>
  );
};

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

const LogoImageWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  height: 28px;
  width: auto;
  margin-right: 2px;
`;

export default Logo;
